import React from 'react';
import logo from '../../components/ui/assets/bdt-genetica-logo.png';
import './ColumnContainer.scss';

function ColumnContainer(props) {
    return (
        <div className='column-container'>
            <div className='aside'>
                <img
                    src={process.env.REACT_APP_LOGO_FULL ?? logo}
                    height='50%'
                    className='fpi-logo d-none d-sm-none d-md-none d-lg-block d-xl-block'
                    alt='Splendor Produce'
                />
                <img
                    src={process.env.REACT_APP_LOGO_SQUARE ?? logo}
                    height='100'
                    className='d-lg-none d-xl-none'
                    alt='Splendor produce-icon'
                />
            </div>
            <div className='control-column'>
                <div className='alt-logo'>
                    <img
                        src={process.env.REACT_APP_LOGO_SQUARE ?? logo}
                        height='80'
                        className='mb-4'
                        alt='Splendor produce-icon'
                    />
                </div>
                {props.children}
            </div>
        </div>
    );
}

export default ColumnContainer;
